import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="100%" alt="Kuro Sushi About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView m="0 auto">
          <CFView column center m="0 auto" maxWidth="1400px">
            <CFImage src={about} w="100%" alt="Promotions" />
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
